/* eslint-disable consistent-return */
import React, { useState, useEffect, DependencyList } from 'react';
import 'intersection-observer';

/*
 * IntersectionObserver用hook
 */
export const useIntersection = (
  ref: React.RefObject<Element>,
  option?: IntersectionObserverInit,
  deps: DependencyList = []
) => {
  const [intersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const node = ref?.current;
    if (!node) return;

    const observer = new IntersectionObserver(([entry]) => {
      setIntersecting(entry.isIntersecting);
    }, option);

    observer.observe(node);
    return () => observer.disconnect();
    // TODO: 修正してdisableを取り除く
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { intersecting };
};

/*
 * IntersectionObserver用hook
 */
export const useIntersectionRect = (ref: React.RefObject<Element>) => {
  const [rect, setRect] = useState<DOMRectReadOnly>();

  useEffect(() => {
    const node = ref?.current;
    if (!node) return;

    const observer = new IntersectionObserver(([entry]) => {
      setRect(entry.boundingClientRect);
    });

    observer.observe(node);
    return () => observer.disconnect();
    // TODO: 修正してdisableを取り除く
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    rect,
  };
};
